import { render, staticRenderFns } from "./UserCreationModal.vue?vue&type=template&id=60715a7a&"
import script from "./UserCreationModal.vue?vue&type=script&lang=js&"
export * from "./UserCreationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports